import { render, staticRenderFns } from "./BookingActionDialog.vue?vue&type=template&id=481ac963&scoped=true"
import script from "./BookingActionDialog.vue?vue&type=script&lang=ts"
export * from "./BookingActionDialog.vue?vue&type=script&lang=ts"
import style0 from "./BookingActionDialog.vue?vue&type=style&index=0&id=481ac963&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481ac963",
  null
  
)

export default component.exports